// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"4abbbac2","604":"33cb2a2a","613":"2ca4616f","673":"04d8b6b4","713":"5bc7d25a","767":"481d60f0","983":"33232c66"}[chunkId] + ".chunk.js";
};